var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamCoachStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.154,
    height: 29.664,
    viewBox: "0 0 31.154 29.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 31.154,
    height: 29.664,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6027",
    "data-name": "Path 6027",
    d: "M31.136,11.3a.376.376,0,0,0-.337-.256l-11.013-.478L15.926.241a.373.373,0,0,0-.7,0l-3.86,10.327L.356,11.046a.372.372,0,0,0-.215.664L8.77,18.57,5.822,29.193a.371.371,0,0,0,.564.408l9.192-6.081L24.77,29.6a.377.377,0,0,0,.2.063.359.359,0,0,0,.219-.07.375.375,0,0,0,.141-.4L22.385,18.57l8.629-6.86a.372.372,0,0,0,.122-.408",
    transform: "translate(0)",
    fill: "#0082ca"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCoachStar);
export default __webpack_public_path__ + "static/media/team-coach-star.326839ec79460433aa3f2eb84766c982.svg";
export { ForwardRef as ReactComponent };